;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	var Component  = APP.module('Component');
	var Model  = APP.module('Model');

	View.Promo = Marionette.ItemView.extend({
		tagName: 'div',
		template: Model.AdCMS ? JST.PromoCMS : JST.ClubsPromo,
		ui: {
			promo: '.clubs-promo'
		},

		initialize: function () {
			if(!JST.PromoCMS && Model.AdCMS ) {
				console.error('Please enable JST.PromoCMS template')
			}

 			this.user = APP.module('instance').user;
			this.model = new Backbone.Model();
			this.model.set({
				over18: this.checkIf18() != -1
			});
			this.initListeners();
			this.initMRECFunctions();
		},

		initMRECFunctions: function () {
			if(APP.MREC_EXTENDS) {
				_.extend(this, APP.MREC_EXTENDS);
				this.initMREC(['promo'])
			}

			return this;
		},

		togglePromo: function () {

			var el = $(this.ui.promo),
				style = this.checkIf18() == -1 ? 'none' : 'block';
			el.css('display', style);
			setTimeout(function () {
				el.parent().parent().css('display', style);
			},0);
		},
		init_ad: function () {

			if (window.mcn_methods.get_club_targeting( window.mcn_methods.get_clubs() ) == 'wtipping' ) {

				this.togglePromo();

				$(this.ui.promo).addClass('wtipping');
				var img = '<img src="' + CONFIG.IMAGES_URL + 'aquisition/aquisition_Racing_300x250.gif" />',
					impressions_img = '<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=20255615&PluID=0&ord=[timestamp]&rtu=-1" BORDER="0" HEIGHT="1" WIDTH="1"/>';
				$(this.ui.promo).html('<a href="https://bs.serving-sys.com/serving/adServer.bs?cn=trd&mc=click&pli=20255615&PluID=0&ord=[timestamp]" target="_blank">' + img + '</a>' + impressions_img);
			}
			else {
				if ( typeof _mcn !== "undefined" && typeof _mcn.amf !== "undefined" ) {

					setTimeout(function () {

						_mcn.config=[];
						_mcn.config.push(function () {
							_mcn.publisher( window.mcn_methods.get_publisher() );
							if ( window.mcn_methods.get_club_targeting( window.mcn_methods.get_clubs() ) !=  'wtipping' ) {
								_mcn.amf.targeting("area",   window.mcn_methods.get_area_targeting( window.mcn_methods.get_pages() ) );
								_mcn.amf.targeting("Club",   window.mcn_methods.get_club_targeting( window.mcn_methods.get_clubs() ) );
								_mcn.amf.targeting("device", window.mcn_methods.get_device_targeting() );
							}
							else {
								_mcn.amf.targeting("area",  'wtipping' );
								_mcn.amf.targeting("device", window.mcn_methods.get_device_targeting() );
								_mcn.amf.postLoadAdCall(true);
							}
						});

						if ( !$('#sidebar-promo').is(':visible') )
							_mcn.amf.insertAd('sidebar-promo');

					}, 0);

				}
			}

			return this;
		},
		onRender: function() {

			this.init_ad();
			return this;
		},
		onShow: function() {
			if (!document.getElementById('#sidebar-promo')) {
				try {
					_telstra.adlib.createAds(['sidebar-promo']);
				} catch (error) { }
			}
			return this;
		},
		getAge: function ( DOB ) {
			if ( !DOB ) return 0;
			var today = new Date(),
				birthDate = new Date(DOB),
				age = today.getFullYear() - birthDate.getFullYear(),
				m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		checkIf18: function () {
			var dob = this.user.get('birthday'),
				age = this.getAge(dob);

			if ( this.ifShowCbt() === false )
				return -1;

			return dob && age >= 18 ? 2 : -1;
		},
		ifShowCbt: function () {
			return this.user.get('hide_odds') && this.user.get('hide_odds') == 0;
		},
		initListeners: function () {
			this.listenTo(APP.vent, 'promo:re-render:updates', this.init_ad);
			this.listenTo(APP.vent, 'route:change',this.init_ad);
			return this;
		}
	})

}(window, APP, Backbone, Marionette, $, _));